import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import moment from 'moment'

import { IonIcon } from 'controls'
import { AuthActionCreators } from 'app/reducers/AuthRedux'
import { paymentRemainder } from './styles'

const PaymentRemainder = ({
  isPaymentRemainderOpen,
  finishedPlan,
  actions: { hidePaymentRemainder }
}) => {
  if (!isPaymentRemainderOpen) {
    return null
  }

  return (
    <section className="container">
      <IonIcon icon="ios-mail" size="small" className="icon-warning" />
      <IonIcon
        icon="md-close"
        size="small"
        className="icon-close"
        onClick={hidePaymentRemainder}
      />
      <h4>
        <b>Tu fecha de corte se acerca</b>
      </h4>
      <p>
        Asegurate de tener habilitado un método de pago, próxima fecha:
        {' '}
        <b>{moment(finishedPlan).format('DD-MM-YYYY')}</b>
      </p>
      <style jsx>{paymentRemainder}</style>
    </section>
  )
}

const mapStateToProps = (state) => ({
  isPaymentRemainderOpen: state.auth.isPaymentRemainderOpen,
  finishedPlan: state.auth.finishedPlan
})

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      hidePaymentRemainder: AuthActionCreators.hidePaymentRemainder
    },
    dispatch
  )
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentRemainder)
